<template>
  <div>
    <VueDatePicker
      v-model="date"
      format="yyyy-MM-dd"
      range
      multi-calendars
      placeholder="Filter by date"
      :clearable="true"
    />
  </div>
</template>

<script lang="ts">
import { VueDatePicker } from '@vuepic/vue-datepicker'
import { defineComponent, ref, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { DATE_FROM, DATE_TO } from '@/const/AssignmentListQueryFilters'
import { useAssignmentStore } from '@/store/assignment'
import moment from 'moment'

export default defineComponent({
  name: 'DateFilter',
  components: { VueDatePicker },
  setup() {
    const date = ref<Date[] | null>(null)
    const route = useRoute()
    const assignmentStore = useAssignmentStore()

    watch(date, (value) => {
      if (value && value[0] && value[1]) {
        const [dateFrom, dateTo] = value
        assignmentStore.updateAssignmentsFilter({
          [DATE_FROM]: moment(dateFrom).format('YYYY-MM-DD'),
          [DATE_TO]: moment(dateTo).format('YYYY-MM-DD'),
        })
      } else {
        assignmentStore.updateAssignmentsFilter({
          [DATE_FROM]: '',
          [DATE_TO]: '',
        })
      }
    })

    onMounted(() => {
      if (route.query[DATE_FROM] && route.query[DATE_TO]) {
        date.value = [moment(String(route.query[DATE_FROM])).toDate(), moment(String(route.query[DATE_TO])).toDate()]
      }
    })

    return {
      date,
    }
  },
})
</script>
